module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"order":"order","rack":"Rack","cross connect order":"Cross Connect Order","patch from":"Patch From: ","patch to":"Patch To: ","order note":"Order Note"},"de":{"order":"bestellen","rack":"Rack","cross connect order":"Cross Connect Bestellung","patch from":"Patch von: ","patch to":"Patch nach: ","order note":"Bestellnotiz"}}')
  delete Component.options._Ctor
}
